var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewBtnM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_37538_4890)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "url(#paint0_linear_37538_4890)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37538_4890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 20.4082H17.4581C19.1681 20.4082 20.5519 18.9668 20.5519 17.1855V8.76562C20.5519 6.99022 19.1681 5.54297 17.4581 5.54297H9.375C7.67061 5.54297 6.28125 6.99022 6.28125 8.76562V17.1855C6.28125 18.9668 7.67061 20.4082 9.375 20.4082ZM10.8938 12.0996H12.5756V10.3477C12.5756 9.86132 12.9525 9.46876 13.4194 9.46876C13.8863 9.46876 14.2631 9.86132 14.2631 10.3477V12.0996H15.9394C16.4062 12.0996 16.7831 12.4922 16.7831 12.9785C16.7831 13.4648 16.4062 13.8574 15.9394 13.8574H14.2631V15.6035C14.2631 16.0898 13.8863 16.4824 13.4194 16.4824C12.9525 16.4824 12.5756 16.0898 12.5756 15.6035V13.8574H10.8938C10.4269 13.8574 10.05 13.4648 10.05 12.9785C10.05 12.4922 10.4269 12.0996 10.8938 12.0996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8746 12.0976C22.4088 12.0976 22.0308 12.491 22.0308 12.9765V19.3125C22.0308 20.7665 20.8954 21.9492 19.4996 21.9492H13.417C12.9509 21.9492 12.5732 22.3426 12.5732 22.8281C12.5732 23.3136 12.9509 23.707 13.417 23.707H19.4996C21.8259 23.707 23.7183 21.7358 23.7183 19.3125V12.9765C23.7183 12.491 23.3404 12.0976 22.8746 12.0976Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_37538_4890",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_37538_4890"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_37538_4890",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37538_4890",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1EA7E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BBBE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37538_4890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18.75,
    fill: "white",
    transform: "translate(6 5.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBtnM);
export default __webpack_public_path__ + "static/media/newBtn-m.0b7667c67336ecc36b99ca308876312b.svg";
export { ForwardRef as ReactComponent };